import { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Button, Row, Col } from 'reactstrap';
import Select from 'react-select';
import { isMobileOnly } from 'react-device-detect';
import useModal from '../../../sharedComponents/useModal/useModal';
import LocalStorage from '../../../sharedComponents/LocalStorage/LocalStorage';
import { Theme, selectStyles } from '../../../config/constants';
import userApi from '../../../api/userApi';
import { toast } from 'react-toastify';
import datasuiteApi from '../../../api/datasuiteApi';

const ShareOpportunityModal = ({id, ...props}) => {
    const { modalProps, headerProps } = useModal(id, {header: {color: 'black', background: 'white'}});
    const mfrName = LocalStorage.manufacturerData.get().nickname || 'Admin';
    const [usersList, setUsersList] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const { selectedCategory, selectedOperator, selectedSegment, selectedState } = props;

    const setupUserOptions = () => {
        const options = usersList?.map(user => ({
            value: user.id,
            label: user.first_name + ' ' + user.last_name,
        }));
        setUserOptions(options);
    };
    
    const getUsers = () => {
        const params = {
            manufacturer : LocalStorage.manufacturerData.get()
        };
        if(params.manufacturer) {
            userApi.post(params).then(({data}) => {
                setUsersList(data);
            }).catch(err => {
                toast.error('Something went wrong getting users');
                console.error(err);
            });
        }
    };

    const handleShare = () => {
        if (selectedUser) {
            const params = {
                categories: selectedCategory?.map((category) => category?.value || '') || [],
                locations: selectedOperator?.map((operator) => operator?.value || '') || [],
                segments: selectedSegment?.map((segment) => segment?.value || '') || [],
                states: selectedState?.map((state) => state?.value || '') || [],
                userId: selectedUser?.value,
                siteUrl: process.env.REACT_APP_BUCKET_URL
            };
            datasuiteApi.matchOpportunityIdentifier.shareReport.post(params).then((response) => {
                toast.success(`Opportunities shared successfully with ${selectedUser.label}`);
            }).catch(err => {
                toast.error(err.data.message || 'Something went wrong sharing these opportunities. Try again later.');
                console.error(err);
            });
        }
    };

    useEffect(() => {
        setUsersList(getUsers());
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (usersList?.length > 0) {
            setupUserOptions();
        }
        // eslint-disable-next-line
    }, [usersList]);

    return (
        <Modal  {...modalProps}>
            <ModalHeader {...headerProps}>Share Opportunities</ModalHeader>
            <ModalBody >
                <Form className= {(isMobileOnly ? 'px-2 text-size-16' : 'px-5 text-size-16')} >
                    <FormGroup >
                        <Label className='label-text-header mb-2'>{mfrName}'s Users</Label>
                        <Select placeholder='Select User' options={userOptions} onChange={(user) => setSelectedUser(user)} value={selectedUser} styles={selectStyles}/>
                    </FormGroup>
                    <Row className='py-2 w-fc mx-auto'>
                        <Col>
                            <Button onClick={() => {handleShare()}} block color={Theme().colors.accentName} className='py-2 px-5 button-label'>Share</Button>
                        </Col>
                    </Row>
                </Form>
            </ModalBody>
        </Modal>
    )
};

export default ShareOpportunityModal;